import { AxiosError } from 'axios';

export class ApiError extends AxiosError<{ message: string; statusCode: number }> {
  //
}

export const isAxiosError = <T = AxiosError>(error: AxiosError | any): error is AxiosError<T> => {
  return error && error.isAxiosError;
};
